import React, { useEffect, useState } from "react";
import { getUserOrders } from "../api/apiServiceFetch";
import "./OrderPopup.scss";

const orderTypeLabels = {
	1: "Premium",
	10: "Invest",
};

const formatDate = (value) => {
	if (!value) return "-";

	const date = new Date(value);
	if (Number.isNaN(date.getTime())) return "-";

	return date.toLocaleDateString("ru-RU");
};

const OrderPopup = ({ userId, visible, onClose }) => {
	const [orders, setOrders] = useState([]);
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		const fetchOrders = async () => {
			if (!userId || !visible) return;

			try {
				setLoading(true);
				const data = await getUserOrders(userId);
				setOrders(Array.isArray(data) ? data : []);
			} catch (err) {
				console.error("Не удалось загрузить покупки пользователя:", err);
				setOrders([]);
			} finally {
				setLoading(false);
			}
		};

		fetchOrders();
	}, [userId, visible]);

	if (!visible) return null;

	return (
		<div className="order-popup-overlay" onMouseDown={onClose}>
			<section
				className="order-popup"
				role="dialog"
				aria-modal="true"
				aria-label="Покупки пользователя"
				onMouseDown={(event) => event.stopPropagation()}
			>
				<header className="order-popup-header">
					<h2>Покупки пользователя</h2>
					<button type="button" className="order-popup-close" onClick={onClose}>
						Закрыть
					</button>
				</header>

				<div className="order-popup-table-wrap">
					<table className="order-popup-table">
						<thead>
							<tr>
								<th>ID</th>
								<th>UUID</th>
								<th>Тип</th>
								<th>Цена</th>
								<th>Огонь</th>
								<th>Ссылка оплаты</th>
								<th>Создан</th>
								<th>Окончание</th>
							</tr>
						</thead>
						<tbody>
							{loading ? (
								<tr>
									<td colSpan={8} className="order-popup-empty">
										Загружаем...
									</td>
								</tr>
							) : orders.length === 0 ? (
								<tr>
									<td colSpan={8} className="order-popup-empty">
										Покупки не найдены
									</td>
								</tr>
							) : (
								orders.map((order) => (
									<tr key={order.id ?? order.orderId ?? order.uuId}>
										<td>{order.id ?? order.orderId ?? "-"}</td>
										<td>{order.uuId ?? "-"}</td>
										<td>{orderTypeLabels[order.type] ?? order.type ?? "-"}</td>
										<td>{order.price ?? "-"}</td>
										<td>{order.superLikes ?? "-"}</td>
										<td className="order-popup-link-cell">
											{order.payLink ? (
												<a
													href={order.payLink}
													target="_blank"
													rel="noopener noreferrer"
												>
													Открыть
												</a>
											) : (
												"-"
											)}
										</td>
										<td>{formatDate(order.createDate)}</td>
										<td>{formatDate(order.endDate)}</td>
									</tr>
								))
							)}
						</tbody>
					</table>
				</div>
			</section>
		</div>
	);
};

export default OrderPopup;
